import { Enemy } from "./Enemy";
import { Engine } from "../Engine";
import { GameConstants } from "../GameConstants";
import { MathUtils } from "../utils/MathUtils";

export class HealerEnemy extends Enemy {

    public healing: boolean;

    private f: number;

    constructor (subtype: string, creationTick: number, engine: Engine, path: {r: number, c: number}[], l?: number, splitted?: boolean) {
        
        super(GameConstants.ENEMY_WATER, subtype, creationTick, engine, path, l, splitted);

        // para que no se paren todos en el mismo lugar y al mismo tiempo
        this.f = GameConstants.HEALER_HEALING_TICKS - creationTick % GameConstants.HEALER_HEALING_TICKS;

        this.healing = false;

    }

    public update(): void {

        this.f ++;

        if (this.healing) {

            this.heal();

            if (this.f >= this.enemyData.healTicks) {
                this.f = 0;
                this.healing = false;
            }

        } else {

            super.update();

            // no cura si ya esta muy cerca de la salida
            if (this.f >= GameConstants.HEALER_HEALING_TICKS) {
                this.f = 0;
                this.healing = true;
            }
        }
    }

    private heal(): void {

        // encontrar a todos los enemigos que esten dentro de un determinado radio y restaurarles la salud
        for (let i = 0; i < this.engine.enemies.length; i ++) {

            const enemy = this.engine.enemies[i];

            if (enemy.id === this.id) {
                // se cura a si mismo
                enemy.restoreHealth(this.enemyData.healPercent);
            } else {
                const distanceSquare = MathUtils.fixNumber((enemy.x - this.x) * (enemy.x - this.x) + (enemy.y - this.y) * (enemy.y - this.y));
                if (distanceSquare <= this.enemyData.healRadius * this.enemyData.healRadius) {
                    enemy.restoreHealth(this.enemyData.healPercent);
                }
            }
        }
    }
}
